import { Chain } from '@ankr.com/chains-list';

import { flatChain } from 'modules/chains/utils/flatChain';
import { getUniqueArray } from 'modules/common/utils/getUniqueArray';

export const getChainIDs = (chain: Chain) => {
  const subchains = flatChain(chain);

  const ids = subchains.map(({ id }) => id);

  return getUniqueArray(ids);
};
